import { gql } from '@apollo/client';

export const ALL_ADD_ONS = gql`
  query AllAddOns {
    addOns: getUserAddOns {
      id
      name
    }
  }
`;
